import React from 'react';

const Janraisig = () => {
    return (
        <h1>Жанрайсиг дацан</h1>
    )
}
export default Janraisig;